/**
 * User-facing copy for bulk / prepared-drop send failures.
 * For Media Devoted | Created By Ciro Autiero
 */

/** SMSWiser / validation responses: show verbatim (do not replace with "add texts" hints). */
function isDetailedSendValidationMessage(msg: string): boolean {
  const l = msg.toLowerCase();
  return (
    l.includes('smswiser:') ||
    l.includes('too long') ||
    l.includes('max 160') ||
    l.includes('cannot use') ||
    l.includes('drop cap') ||
    l.includes('batch sending') ||
    l.includes('ai optimization') ||
    l.includes('only new domains') ||
    (l.includes(';') && msg.length > 55)
  );
}

function missingSetupHint(msg: string): string | null {
  const l = msg.toLowerCase();
  if (l.includes('sender template is required')) return 'Add sender names.';
  if (l.includes('text template is required')) return 'Add SMS texts.';
  if (l.includes('leads list is required')) return 'Select a leads list.';
  if (
    l.includes('campaign') &&
    (l.includes('not found') || l.includes('unknown') || l.includes('invalid'))
  ) {
    return 'Add a campaign first. Ensure the campaign exists in SMSWiser.';
  }
  return null;
}

function joinDistinctErrors(unique: string[]): string {
  if (unique.length === 1) return unique[0]!;
  const joined = unique.join(' · ');
  if (joined.length <= 480) return joined;
  return `${unique[0]!} (+${unique.length - 1} more distinct errors)`;
}

/**
 * Build user-friendly send error description from counts and optional backend messages.
 * Maps only clear "missing template" errors to short hints; preserves SMSWiser validation text.
 */
export function formatSendErrorDescription(params: {
  sent: number;
  failed: number;
  errorMessages?: string[];
}): string {
  const { sent, failed, errorMessages = [] } = params;
  const counts = `${sent} sent, ${failed} failed.`;
  const unique = [...new Set(errorMessages.map((m) => m.trim()).filter(Boolean))];
  if (unique.length === 0) return counts;

  const primary = unique[0]!;
  if (isDetailedSendValidationMessage(primary)) {
    return `${joinDistinctErrors(unique)} ${counts}`;
  }

  const hint = missingSetupHint(primary);
  if (hint) return `${hint} ${counts}`;
  return `${joinDistinctErrors(unique)} ${counts}`;
}
